/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliTeacherInstitutionMemberDto } from '../../models/amoxcalli-teacher-institution-member-dto';

export interface ApiTeacherInstitutionsByInstitutionInstitutionIdGet$Plain$Params {
  institutionId: string;
}

export function apiTeacherInstitutionsByInstitutionInstitutionIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiTeacherInstitutionsByInstitutionInstitutionIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliTeacherInstitutionMemberDto>>> {
  const rb = new RequestBuilder(rootUrl, apiTeacherInstitutionsByInstitutionInstitutionIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('institutionId', params.institutionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliTeacherInstitutionMemberDto>>;
    })
  );
}

apiTeacherInstitutionsByInstitutionInstitutionIdGet$Plain.PATH = '/api/teacher-institutions/by-institution/{institutionId}';
